import { getDefaultExportFromCjs as a } from "./index361.js";
import { __require as r } from "./index770.js";
var o = r();
const l = /* @__PURE__ */ a(o);
export {
  l as default
};
